import React from "react";
import { Table } from "react-bootstrap";

import { PropertyFeature } from "../../utils/interface";
import DeleteButton from "../DeleteButton";

interface ListPropertyFeaturesProps {
  propertyFeatures: PropertyFeature[];
  onDeletePropertyFeature: (propertyId: number, propertyFeatureId: number, fromDate: string) => void;
}

const ListPropertyFeatures: React.FC<ListPropertyFeaturesProps> = ({
  propertyFeatures,
  onDeletePropertyFeature,
}) => {
  return (<>
    <Table striped hover size="sm">
      <thead>
        <tr>
          <th>ID#</th>
          <th>Type</th>
          <th>Description</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        {propertyFeatures.map((propertyFeature: PropertyFeature) => (
          <tr key={propertyFeature.propertyFeatureId}>
            <td>{propertyFeature.propertyFeatureId}</td>
            <td>{propertyFeature.propertyFeatureTypeEnumDescription}</td>
            <td>{propertyFeature.description}</td>
            <td>
              <DeleteButton
                onClick={() => onDeletePropertyFeature(
                  propertyFeature.propertyId,
                  propertyFeature.propertyFeatureId,
                  propertyFeature.fromDate)
                }
              />
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  </>)
};

export default ListPropertyFeatures;
